import classNames from 'classnames';

import VerticalBarGraph from '/@/components/vertical-bar-graph';

import double_arrow_svg from './assets/double-arrow.svg?url';
import styles from './styles.module.css';

const ComparativeVerticalBarsGraph = ({ barConfig1 = {}, barConfig2 = {}, selectedIndex, direction = 'column' }) => {
    barConfig1['direction'] = direction;
    barConfig2['direction'] = direction;
    barConfig1['selectedIndex'] = selectedIndex;
    barConfig2['selectedIndex'] = selectedIndex;

    const valuesIndexRange = [...Array(barConfig1.values.length).keys()];
    const middleBarCellClassNames = (index) =>
        classNames(styles.middleBarCell, {
            [styles.selectedMiddleBarCell]: index == selectedIndex,
        });

    return (
        <div className={styles.root}>
            <div className={styles.bar}>
                <VerticalBarGraph {...barConfig1} />
            </div>
            <div
                className={classNames(styles.bar, styles.middleBar)}
                style={{
                    flexDirection: direction,
                }}
            >
                {valuesIndexRange.map((i) => (
                    <div key={i} className={middleBarCellClassNames(i)}>
                        {i == selectedIndex && <img src={double_arrow_svg} alt='double-arrow' />}
                    </div>
                ))}
            </div>
            <div className={styles.bar}>
                <VerticalBarGraph {...barConfig2} />
            </div>
        </div>
    );
};

export default ComparativeVerticalBarsGraph;
